module.exports = __webpack_public_path__ + "img/conflict-confronter.15bb70ff.svg";